import SectionSubtitle from './SectionSubtitle';

export default SectionSubtitle;
